__turbopack_context__.v({
  "loading-button": "sticky-footer-content-module-scss-module__EboukG__loading-button",
});
